import React, { forwardRef } from 'react';
import firebase from "../config/firebase";
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button, colors } from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';
import PeopleIcon from '@material-ui/icons/People';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HealingIcon from '@material-ui/icons/Healing';
import { AuthContext } from '../Auth.js'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: 'medium'
  },
  icon: {
    color: 'gray',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: 8
  },
  active: {
    color: 'gray',
    fontWeight: 'medium',
    '& $icon': {
      color: 'gray'
    }
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));


const handlelogout = () => {
  firebase.auth().signOut().then(function() {
  }).catch(function(error) {
      console.log(error)
  });
};


const SidebarNav = props => {
  const { className, ...rest } = props;
  const {userProfile} = React.useContext(AuthContext);
  const classes = useStyles();
  var pages   = [
    {
      title: 'Calendario',
      href: '/',
      icon: <ScheduleIcon />
    },
    {
      title: 'Perfil',
      href: '/perfil',
      icon: <AccountBoxIcon />
    }
  ];
  if (!userProfile) {
    return (
      <></>
    );
  }
  const { organizador } = userProfile
  if (organizador ) {
    pages = [
      {
        title: 'Calendario',
        href: '/',
        icon: <ScheduleIcon />
      },
      {
        title: 'Voluntarios',
        href: '/voluntarios',
        icon: <PeopleIcon />
      },
      {
        title: 'Sanidad',
        href: '/sanidad',
        icon: <HealingIcon />
      },
      {
        title: 'Perfil',
        href: '/perfil',
        icon: <AccountBoxIcon />
      }
    ];
  }
  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {pages.map(page => (
        <ListItem
          className={classes.item}
          disableGutters
          key={page.title}
        >
          <Button
            activeClassName={classes.active}
            className={classes.button}
            component={CustomRouterLink}
            to={page.href}
          >
            <div className={classes.icon}>{page.icon}</div>
            {page.title}
          </Button>
        </ListItem>
      ))}
      <ListItem
          className={classes.item}
          disableGutters
          key="logout"
        >
        <Button
          onClick={handlelogout}
        >
          <div className={classes.icon}><ExitToAppIcon /></div>
          Salir
        </Button>
      </ListItem>
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string
};

export default SidebarNav;
